import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { apiInstance } from "./axiosApi";
import authHeader from "./authHeader";

export const getDashboardData = createAsyncThunk(
  "dashboard/getDashboardData",
  async ({ startDate = null, endDate = null } = {}, { rejectWithValue }) => {
    const params = {};
    if (startDate || endDate) {
      params.dateFilter = {};
      if (startDate) params.dateFilter.startDate = startDate;
      if (endDate) params.dateFilter.endDate = endDate;
    }

    try {
      const response = await apiInstance.get("/dashboard", {
        headers: authHeader(),
        params,
      });
      return response;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);

  const initialState = {
    dashboardLoading: false,
    recentTransactionLoading: false,
    staticData: "",
  };
  
  const dashboardSlice = createSlice({
    name: "dashboardSlice",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
      builder.addCase(getDashboardData.pending, (state, action) => {
        state.staticDataLoading = true;
      });
      builder.addCase(getDashboardData.fulfilled, (state, action) => {
        state.staticData = action.payload.data;
        state.staticDataLoading = false;
      });
      builder.addCase(getDashboardData.rejected, (state, action) => {
        state.staticDataLoading = false;
      });
      
    },
  });
  export default dashboardSlice.reducer;